export const isTruthyString: (string: string) => boolean = (string: string): boolean => string === 'true';
